import { render, staticRenderFns } from "./roomRocket.vue?vue&type=template&id=672ad329&scoped=true"
import script from "./roomRocket.vue?vue&type=script&lang=js"
export * from "./roomRocket.vue?vue&type=script&lang=js"
import style0 from "./roomRocket.vue?vue&type=style&index=0&id=672ad329&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ad329",
  null
  
)

export default component.exports